import { render } from "./materialItem.vue?vue&type=template&id=0391192c&scoped=true"
import script from "./materialItem.vue?vue&type=script&lang=js"
export * from "./materialItem.vue?vue&type=script&lang=js"

import "./materialItem.vue?vue&type=style&index=0&id=0391192c&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0391192c"]])

export default __exports__